import "core-js/modules/es6.array.map";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
export default function fetchJsFromCDN(src, externals) {
  if (externals === void 0) {
    externals = [];
  }
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.setAttribute('src', src);
    script.addEventListener('load', function () {
      resolve(externals.map(function (key) {
        var ext = window[key];
        typeof ext === 'undefined' && console.warn("No external named '" + key + "' in window");
        return ext;
      }));
    });
    script.addEventListener('error', reject);
    document.body.appendChild(script);
  });
}